import { Alert, Box, Button, Container, FormControl, InputAdornment, InputLabel, LinearProgress, MenuItem, Select, Skeleton, Snackbar, Stack, TextField, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import AddIcon from '@mui/icons-material/Add';
import { useSelector,useDispatch } from 'react-redux';
import {showmodal,ajout,getList,remove,modalModifShow,current,modif,getsecteur} from './clientSlice';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

import Ajouter from './Ajouter';
import Modifier from './Modifier';

import SearchIcon from '@mui/icons-material/Search';

export default function Clients() {
  const userData = useSelector(state => state.userData);
  const [Chargement, setChargement] = useState(false);
  const id = userData.id;
  const apitoken = userData.apitoken;
  const apiUrl = process.env.REACT_APP_API_URL;

  const clientData=useSelector(state => state.clientsData);
  const listClient=clientData.list
  const listSecteur=clientData.listSecteur
  const ajoutSuccess = clientData.ajoutOk
  const modifSuccess = clientData.modifOk
  const [removeSuccess, setRemoveSuccess] = useState(false);
  const [Progession, setProgession] = useState(false);
  const [rechercheNom,setRchercheNom] = useState('');
  const [recherchePrenom,setrecherchePrenom] = useState('');
  const [valSecteur, setvalSecteur] = useState('Tout');
  const [valCategorie, setvalCategorie] = useState('Tout');

  const rechercheNomField = useRef('')
  const recherchePrenomField = useRef('')

  const handleSecteurChange = (event) => {
    setvalSecteur(event.target.value);
  };

  const handleCategorieChange = (event) => {
    setvalCategorie(event.target.value);
  };

  const dispatch= useDispatch();
  const navigate = useNavigate();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(ajout(false));
    dispatch(modif(false));
    setRemoveSuccess(false);
  };

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: theme.palette.common.black,
          color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
          fontSize: 14,
        },
      }));
      
      const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
          border: 0,
        },
      }));

      const suppression = async (idclient)=> {
        setProgession(true);

        try {
            const response = await axios.post(`${apiUrl}delete/client/${id}/${apitoken}/${idclient}`);
            if(response.data.status==="ok")
                {
                    dispatch(remove(idclient));
                    setRemoveSuccess(true);
                    setProgession(false);
                }
        } catch (error) {
          navigate('/');
        }
    }
    
      const supprimer = (idclient,nom,prenom) => {
        let result = window.confirm(`Supprimer le client ${nom} ${prenom} ?`);
        if (result === true) {
            suppression(idclient);
        }
    }

    const modifier = (id) => {
      dispatch(modalModifShow(true));
      const valeur = listClient.find(client => client._id === id);
      dispatch(current(valeur));
  };


  const exportCSV = () => {

    let listFiltre = [...listClient];

    // Recherche par nom
    if (rechercheNom.length > 2) {
        listFiltre = listFiltre.filter(
            client =>
                client.nom
                    ?.toLowerCase()
                    .includes(rechercheNom.toLowerCase())
        );
    }

    // Recherche par prénom
    if (recherchePrenom.length > 2) {
        listFiltre = listFiltre.filter(
            client =>
                client.prenom
                    ?.toLowerCase()
                    .includes(recherchePrenom.toLowerCase())
        );
    }

    // Filtre secteur
    if (valSecteur !== "Tout") {
        listFiltre = listFiltre.filter(
            client => client.secteur?.id === valSecteur
        );
    }

    // Filtre catégorie
    if (valCategorie !== "Tout") {
        listFiltre = listFiltre.filter(
            client => client.categorie === valCategorie
        );
    }

    const rows = [];

    // En-tête CSV
    rows.push([
        "Code",
        "Nom",
        "Prénom",
        "Téléphone",
        "Adresse",
        "Catégorie",
        "Secteur",
        "Ville",
        "ICE",
        "Banque",
        "N° compte"
    ]);

    // Données
    listFiltre.forEach(client => {

        rows.push([
            client.client_code || "",
            client.nom || "",
            client.prenom || "",
            client.tel || "",
            client.adresse || "",
            client.categorie || "",
            client.secteur?.designation || "",
            client.ville || "",
            client.ice || "",
            client.banque || "",
            client.compte || ""
        ]);

    });

    // Génération CSV
    const csvContent =
        "\uFEFF" +
        rows
            .map(row =>
                row
                    .map(value =>
                        `"${String(value ?? "").replace(/"/g, '""')}"`
                    )
                    .join(";")
            )
            .join("\r\n");

    const blob = new Blob(
        [csvContent],
        {
            type: "text/csv;charset=utf-8;"
        }
    );

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;
    link.download = "Liste_clients.csv";

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

    URL.revokeObjectURL(url);
};

      function ShowList() {
        if(listClient.length > 0){
          let listFiltre=listClient
          if(rechercheNom.length > 2) {
            listFiltre = listFiltre.filter(client => client.nom.toLowerCase().includes(rechercheNom.toLowerCase()))
        }
        if(recherchePrenom.length > 2) {
          listFiltre = listFiltre.filter(client => client.prenom.toLowerCase().includes(recherchePrenom.toLowerCase()))
      }
      if(valSecteur!=="Tout") {
        listFiltre = listFiltre.filter(client => client.secteur["id"] === valSecteur)
    }
    if(valCategorie!=="Tout") {
      listFiltre = listFiltre.filter(client => client.categorie === valCategorie)
  }
          return listFiltre.map(Client => {
            return(
              <StyledTableRow key={Client._id}>
              <StyledTableCell component="th" scope="row">
                {Client.client_code}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
                {Client.nom}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
                {Client.prenom}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
                {Client.tel}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
                {Client.adresse}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
                {Client.categorie}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
                {Client.secteur["designation"]}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
                {Client.ville}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
                {Client.ice}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
                {Client.banque}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
                {Client.compte}
              </StyledTableCell>
              <StyledTableCell align="right">
              <Button sx={{width:'135px'}} variant="outlined" color='secondary' startIcon={<EditIcon />} onClick={() => modifier(Client._id)}>
               Modifier
              </Button>      
              <Button sx={{ marginTop: '10px' }} variant="outlined" color='error' startIcon={<DeleteIcon />} onClick={() => supprimer(Client._id,Client.nom,Client.prenom)}>
               Supprimer
              </Button>
              </StyledTableCell>
            </StyledTableRow>
            )

          })
          }
          else {
            return (
              <StyledTableRow>
              <StyledTableCell align='center' colSpan={12} component="th" scope="row">
              Pas de données
              </StyledTableCell>
            </StyledTableRow>
            )
          }
          }

      const getClients=async () => {
        setChargement(true);
        try {
        const response = await axios.post(`${apiUrl}clients/${id}/${apitoken}`,
          {
            timeout: 20000,
          }
        );
        dispatch(getList(response.data));
        }
     catch (error) {
      navigate('/');    
    }
    setChargement(false);
    }
    const Recherche=(event) =>{
      const nom=rechercheNomField.current.value
      const prenom=recherchePrenomField.current.value
      if(nom!==rechercheNom){
        setRchercheNom(nom)
         }
         if(prenom!==recherchePrenom){
          setrecherchePrenom(prenom)
           }
    }

    const GetSecteur=async () => {

      try {
      const response = await axios.post(`${apiUrl}secteurs/${id}/${apitoken}`,
        {
          timeout: 20000,
        }
      );
      dispatch(getsecteur(response.data));
      }
   catch (error) {
    navigate('/');    
  }
  }

      useEffect(() =>{
        getClients();
        GetSecteur();
        dispatch(showmodal(false));
        },[]);

  return (
    <Container maxWidth="lg" sx={{ marginTop: '40px' }}>
    <Typography variant="h4" align='center' color="primary">
        Clients
        </Typography>

        <Box display="flex" width="100%" mt={5}>
        {Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={241} />
         :
        <TextField
        onKeyUp={Recherche}
        inputRef={rechercheNomField}
        id="input-with-icon-textfield"
        label="Recherche Nom"
        size='normal'
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        variant="outlined"
      />
       }
             <Box sx={{ marginLeft: 2 }}>
             {Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={241} />
         :
        <TextField
        onKeyUp={Recherche}
        inputRef={recherchePrenomField}
        id="input-with-icon-textfield2"
        label="Recherche Prénom"
        size='normal'
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        variant="outlined"
      />
       }
              
             </Box>
             <Box sx={{ marginLeft: 2 }}>
{Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={150} />
         :
         <FormControl sx={{ minWidth: 150 }}>
         <InputLabel id="demo-simple-select-label">Secteur</InputLabel>
         <Select
         
         labelId="demo-simple-select-label"
         id="demo-simple-select"
         value={valSecteur}
         label="Marque"
         onChange={handleSecteurChange}
       >
        <MenuItem value='Tout'>Tout</MenuItem>
         {listSecteur.map((item) => (
         <MenuItem key={item._id} value={item._id}>
           {item.designation}
         </MenuItem>
       ))}
         </Select>
         </FormControl>
}
</Box>

<Box sx={{ marginLeft: 2 }}>
{Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={150} />
         :
         <FormControl sx={{ minWidth: 150 }}>
         <InputLabel id="demo-simple-select-label">Catégorie</InputLabel>
         <Select
         
         labelId="demo-simple-select-label"
         id="demo-simple-select"
         value={valCategorie}
         label="Catégorie"
         onChange={handleCategorieChange}
       >
        <MenuItem value='Tout'>Tout</MenuItem>
        <MenuItem value="AG">AG</MenuItem>
        <MenuItem value="Café">Café</MenuItem>
        <MenuItem value="Restaurant">Restaurant</MenuItem>
        <MenuItem value="Dépôt de lait">Dépôt de lait</MenuItem>
        <MenuItem value="Kiosque">Kiosque</MenuItem>
        <MenuItem value="Boulangerie">Boulangerie</MenuItem>

         </Select>
         </FormControl>
}
</Box>
<Box
    style={{ marginLeft: 'auto' }}
    sx={{
        display: 'flex',
        gap: 1
    }}
>

      <Button
        variant="contained"
        size="large"
        color="primary"
        startIcon={<AddIcon />}
        onClick={() => dispatch(showmodal(true))}
    >
        Nouveau Client
    </Button>

    <Button
        variant="contained"
        size="large"
        color="success"
        onClick={exportCSV}
    >
        Exporter
    </Button>


</Box>
        </Box>
        {Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={200} />
         :
         <>
        <TableContainer sx={{ marginTop: '20px' }} component={Paper}>
          
          { Progession ?
    <Box >
  <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
        <LinearProgress color="success" />
      </Stack>
    </Box>
            :
            ''
            }
          
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
          <StyledTableCell>Code</StyledTableCell>
            <StyledTableCell>Nom</StyledTableCell>
            <StyledTableCell>Prénom</StyledTableCell>
            <StyledTableCell>Tel.</StyledTableCell>
            <StyledTableCell>Adresse</StyledTableCell>
            <StyledTableCell>Catégorie</StyledTableCell>
            <StyledTableCell>Secteur</StyledTableCell>
            <StyledTableCell>Ville</StyledTableCell>
            <StyledTableCell>ICE</StyledTableCell>
            <StyledTableCell>Banque</StyledTableCell>
            <StyledTableCell>N° compte</StyledTableCell>
            <StyledTableCell align="right">Actions</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <ShowList/>
        </TableBody>
      </Table>
    </TableContainer>
    </>
}
          <Ajouter/>
          <Modifier/>

          <Snackbar open={ajoutSuccess} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Client ajouté avec succès
        </Alert>
      </Snackbar>

      <Snackbar open={modifSuccess} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Client modifié avec succès
        </Alert>
      </Snackbar>

      <Snackbar open={removeSuccess} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Client supprimé avec succès
        </Alert>
      </Snackbar>
        </Container>
  )
}
